<script setup lang="ts">
// This starter template is using Vue 3 <script setup> SFCs
// Check out https://v3.vuejs.org/api/sfc-script-setup.html#sfc-script-setup
import { onMounted, onUnmounted } from "@vue/runtime-core";
/*import socket from "./socket";
const VERSION = import.meta.env.VITE_APP_VERSION;
onMounted(() => {
  socket.connect();
});
onUnmounted(() => {
  socket.disconnect();
});
*/
onMounted(() => {
  //locale.value = "cn";
  commonStore.getHKPublicHoliday();
});

import HeaderMain from "@/components/shared/header/HeaderMain.vue";
import SiteMap from "@/components/shared/footer/SiteMap.vue";
import PathToWebchat from "@/components/shared/footer/PathToWebchat.vue";
//import CookieAccept from "@/components/cookie/CookieAccept.vue";
import { useHeaderStore } from "@/stores/header";
import { useCommonStore } from "@/stores/common";
import { useI18n } from "vue-i18n";
const headerStore = useHeaderStore();
const commonStore = useCommonStore();

const { t, locale } = useI18n();

onMounted(async () => {
  window.addEventListener("scroll", updateScroll);
});

const updateScroll = () => {
  // for scrolling shadow of header
  headerStore.scrollPosition = window.scrollY;
  //update cookie accept component
  //document.getElementById("cookieAccept").getElementsByClassName("cookie__bar__postpone-button")[0].click();
};
</script>


<template>
  <div id="app" @scroll="scrollMainPage()">
    <main class="w-full min-h-[100%] font-lora text-primary" style="min-width: 100%">
      <HeaderMain />
      <router-view />
      <SiteMap v-if="headerStore.routerName != 'comingsoon' && headerStore.routerName != 'pathNotFound' && headerStore.routerName != 'promotion'" />
      <PathToWebchat v-if="headerStore.routerName == 'home'" />
      <!--<CookieAccept />-->
    </main>
    <span class="absolute bottom-0 left-0 text-xs text-white text-opacity-20">{{ VERSION }}</span>
  </div>
</template>

<!-- change i18n lang: 
locale.value = 'cn'
-->


<style>
ol {
  list-style: auto !important;
  padding-left: 1.4vw !important;
}
ul > li {
  list-style: none;
}

ul > li:before {
  content: "•";
  font-size: 0.8vw;
  vertical-align: middle;
  line-height: 1.2vw;
  padding-right: 0.4vw;
}

/* Customize the label (the radio-container) */
.radio-container {
  display: block;
  position: relative;
  padding-left: 1.6vw;
  /*margin-bottom: 12px;*/
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 1.2vw;
  width: 1.2vw;
  background-color: #eee;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.radio-container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.radio-container input:checked ~ .checkmark {
  background-color: #2196f3;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.radio-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.radio-container .checkmark:after {
  top: 0.4vw;
  left: 0.4vw;
  width: 0.4vw;
  height: 0.4vw;
  border-radius: 50%;
  background: white;
}

.checkbox-container {
  display: block;
  position: relative;
  padding-left: 1.6vw;
  margin-bottom: 0.6vw;
  cursor: pointer;
  /*font-size: 1.1vw;*/
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkbox-checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 1.2vw;
  width: 1.2vw;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.checkbox-container:hover input ~ .checkbox-checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.checkbox-container input:checked ~ .checkbox-checkmark {
  background-color: #2196f3;
}

/* Create the checkbox-checkmark/indicator (hidden when not checked) */
.checkbox-checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkbox-checkmark when checked */
.checkbox-container input:checked ~ .checkbox-checkmark:after {
  display: block;
}

/* Style the checkbox-checkmark/indicator */
.checkbox-container .checkbox-checkmark:after {
  left: 0.4vw;
  top: 0.25vw;
  width: 0.35vw;
  height: 0.55vw;
  border: solid white;
  border-width: 0 0.2vw 0.2vw 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

/* datepicker input width */
.el-input__inner {
  color: black !important;
  font-size: 0.9vw !important;
}

.el-input__inner::placeholder,
input::placeholder,
select option:disabled {
  color: inherit !important;
  font-size: 0.9vw !important;
}

/* tabs style */
.el-tabs__nav-wrap::after {
  background-color: transparent !important;
}
.el-tabs__item {
  font-family: jost;
  font-size: 20px !important;
  color: #a4a4a4 !important;
}
.el-tabs__header {
  margin-bottom: 3.1vw !important;
}

.openpositions-tabs > .el-tabs__header > .el-tabs__nav-wrap > .el-tabs__nav-scroll > .el-tabs__nav > .el-tabs__item.is-active {
  color: #603813 !important;
  font-weight: 700 !important;
}
.openpositions-tabs > .el-tabs__header > .el-tabs__nav-wrap > .el-tabs__nav-scroll > .el-tabs__nav > .el-tabs__item:hover {
  color: #06595c !important;
}
.openpositions-tabs > .el-tabs__header > .el-tabs__nav-wrap > .el-tabs__nav-scroll > .el-tabs__nav > .el-tabs__active-bar {
  background-color: #06595c;
}

input {
  height: 2.55vw !important;
}

.placeholder-bold::placeholder {
  font-weight: bold;
}

.input-boxshadow {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

textarea {
  height: 8vw !important;
}

.bullet-big > li {
  list-style: none;
}

.bullet-big > li:before {
  content: "•";
  font-size: 8vw;
  vertical-align: bottom;
  line-height: 0.5vw;
  padding-right: 0.1vw;
  font-family: Jost, sans-serif;
}
</style>